import { AbilityBuilder, Ability } from "@casl/ability";
import { useStoreState } from "easy-peasy";

const defineAbilitiesFor = (user) => {
  const { can, cannot, rules } = new AbilityBuilder();

  can("All", "Ana Sayfa");
  can("All", "Kullanıcı");
  (user?.groupAuths || []).forEach((element) => {
    for (const [key, value] of Object.entries(element)) {
      if (key.startsWith("auth")) {
        let auth = key.replace("auth", "");
        if (value) can(auth, element.auth.name);
        else cannot(auth, element.auth.name);
      }
    }
  });

  return new Ability(rules);
};

const AuthCheck = (abilities, action, subject) => {
  return abilities.can(action, subject) || abilities.can("All", subject);
};

const AUTH_ACTIONS = {
  ALL: "All",
  MENU: "Menu",
  NEW_RECORD: "NewRecord",
  READ: "Read",
  WRITE: "Write",
  DELETE: "Delete",
  READ_ARCHIVE: "ReadArhive",
  RESTORE_ARCHIVE: "ReturnArchive",
};

const AUTH_SUBJECTS = [
  {
    name: "İşlemler",
    auth_actions: [AUTH_ACTIONS.ALL, AUTH_ACTIONS.MENU],
    children: [
      { name: "Sözleşmeler" },
      {
        name: "Lojman Kira Ödeme Listesi",
        auth_actions: [
          AUTH_ACTIONS.ALL,
          AUTH_ACTIONS.MENU,
          AUTH_ACTIONS.READ,
          AUTH_ACTIONS.WRITE,
        ],
      },
    ],
  },
  {
    name: "Ana Veriler",
    auth_actions: [AUTH_ACTIONS.ALL, AUTH_ACTIONS.MENU],
    children: [
      { name: "Muhataplar" },
      { name: "Birimler" },
      { name: "Alt Birimler" },
      { name: "Kiralanabilir Alanlar" },
      { name: "Konut Puanlama Formları" },
    ],
  },
  {
    name: "Taşınmazlar",
  },
  {
    name: "Parametreler",
    auth_actions: [AUTH_ACTIONS.ALL, AUTH_ACTIONS.MENU],
    children: [
      {
        name: "Ana Veriler",
        onlyNavigation: true,
        children: [
          { name: "Muhatap Türleri" },
          { name: "Kişi Görevi" },
          { name: "Görev Ayrım Ünvanı" },
          { name: "Kiralanabilir Alan Tipleri" },
          { name: "Alt Birim Tipleri" },
        ],
      },
      {
        name: "Sözleşme",
        onlyNavigation: true,
        children: [
          { name: "Sözleşme Tipleri" },
          { name: "Koşul Tipleri" },
          { name: "Koşul Amaçları" },
          { name: "Uzama Kuralları" },
          { name: "Bildirim Tipleri" },
          { name: "Artış Kuralları" },
          { name: "Vade Birimleri" },
          { name: "Sıklık Birimleri" },
        ],
      },
      {
        name: "Taşınmaz",
        onlyNavigation: true,
        children: [
          { name: "Gayrimenkul Tipleri" },
          { name: "Gayrimenkul Durumları" },
          { name: "Tapu Türleri" },
          { name: "Çıkış Şekilleri" },
          { name: "Edinme Şekilleri" },
          { name: "Taşınmaz Nitelikleri" },
          { name: "Hukuki Durumlar" },
          { name: "Organizasyonlar" },
          { name: "Tahsis Amaçları" },
        ],
      },
      {
        name: "Birim ve Ölçümler",
        onlyNavigation: true,
        children: [
          { name: "Donanım Tipleri" },
          { name: "Donanım Markaları" },
          { name: "Ölçüm Tipleri" },
        ],
      },
      {
        name: "Diğer",
        onlyNavigation: true,
        children: [
          { name: "E-Posta Grupları" },
          { name: "Kurallar" },
          { name: "Kullanıcı Birimleri" },
        ],
      },
    ],
  },
  {
    name: "Raporlar",
    auth_actions: [AUTH_ACTIONS.ALL, AUTH_ACTIONS.MENU],
    children: [
      { name: "Sözleşme Raporları" },
      { name: "Kreş Raporları" },
      { name: "Lojman Raporları" },
      { name: "Taşınmaz Raporları" },
      { name: "Konut Puanlama Raporları" },
    ],
  },
  {
    name: "Kullanıcı İşlemleri",
    auth_actions: [AUTH_ACTIONS.ALL, AUTH_ACTIONS.MENU],
    children: [
      { name: "Kullanıcı Listesi" },
      { name: "Kullanıcı Grupları" },
      { name: "Kullanıcı Etkinlikleri" },
    ],
  },
];

export default defineAbilitiesFor;
export { AuthCheck, AUTH_ACTIONS, AUTH_SUBJECTS };
